<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      account: 'getCurrentAccount',
    }),
  },
};
</script>

<template>
  <div class="account-context">
    <woot-button
      variant="clear"
      color-scheme="white"
      class-names="group justify-start p-3 rounded-lg text-white hover:text-woot-500 dark:hover:text-white hover:bg-primary-900/40 transition-colors"
      @click="$emit('toggleAccounts')"
    >
      <div
        class="flex items-center gap-2 text-left text-white group-hover:text-woot-500 dark:group-hover:text-white transition-colors"
      >
        <div
          class="flex items-center justify-center w-6 h-6 rounded-md bg-primary-900/40"
        >
          <fluent-icon icon="briefcase" size="16" class="text-inherit" />
        </div>
        <div class="flex flex-col items-start overflow-hidden">
          <span
            class="max-w-[180px] overflow-hidden text-sm font-medium text-inherit text-ellipsis whitespace-nowrap"
            :title="account.name"
          >
            {{ account.name }}
          </span>
        </div>
        <fluent-icon
          icon="arrow-swap"
          size="16"
          class="flex-shrink-0 text-woot-500 transition-colors dark:group-hover:text-white"
        />
      </div>
    </woot-button>
  </div>
</template>
